import * as React from 'react'
import {Box, LinearProgress, Typography} from "@mui/material";
import {TooltipSeeker} from "@ui-seeker/core";


const styles = {
	height: 10,
	borderRadius: 5,
	backgroundColor: "divider",

	".MuiLinearProgress-bar": {
		backgroundColor: "#fe813b",
	}
}

export default function competitorColumn() {
	return {
		name: 'totalCompetitors', label: 'Competitor Overview',
		options: {
			filter: false,
			headerAlign: 'left',
			sortOrder: 'desc',
			customBodyRowRenderLite: (value, { minCompetitors, shareCompetitors }) => <Box>
				<TooltipSeeker title={`Competitors Lower Price ${minCompetitors}`} useLight componentsProps={{ arrow: { sx: { left: "-50px !important" } } }}>
					<Box sx={{ width: 1, mr: 1 }}>
						<LinearProgress variant="determinate" value={shareCompetitors} sx={styles} />
					</Box>
				</TooltipSeeker>
				<Typography color="text.secondary" sx={{ textAlign: 'right', fontStyle: 'italic', fontSize: 10 }}>
					Total: {value}
				</Typography>
			</Box>
		}
	}
}